import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col } from 'reactstrap';
import { baseURL } from '../../_helpers';
export class EOD extends React.Component {
    constructor(props) {
        super(props);

      
           this.columns = [
            {
                key: "DATE",
                TrOnlyClassName: 'tsc',
                text: "Date",
                className: "tsc",
                align: "left"
            },
            {
                key: "payout_ratio",
                text: "Payout Ratio",   
                TrOnlyClassName: 'tsc',
                className: "tsc",
                align: "left",
            },
            {
                key: "TOTAL_DEPOSITS",
                TrOnlyClassName: 'tsc',
                text: "Total Deposit",
                className: "tsc",
                align: "left"
            },
            {
                key: "TOTAL_WITHDRAWALS",
                TrOnlyClassName: 'tsc',
                text: "Total Withdrawal",
                className: "tsc",
                align: "left"
            },
            {
                key: "net_cashflow",
                TrOnlyClassName: 'tsc',
                text: "Net Cash Flow",
                className: "tsc",
                align: "left"
            },
        ];
        this.config = {
            key_column: "tsc",
            length_menu: [50, 100, 150],
            show_filter: true,
            show_pagination: true,
            pagination: 'advance',
            page_size: 20,
            show_length_menu: true,
           
            language: {
                loading_text: "Please be patient while data loads...",
                no_data_text: "No data was found",
                filter: "Enter date (YYYY-MM-DD)",

                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            },
            button: {
                excel: true,
                print: true,
                csv: true
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
    }
    componentDidMount() {
        this.getData();
    }

    getData = (queryString = "") => {
        this.setState({
            isLoading: true,
        })
        let url = baseURL + "netcashflow?" + queryString
        console.log("query", url);

        axios.all([
            axios.get(url)
            ]).then(axios.spread((branchResponse, entityResponse,) => {
            this.setState({
                admins: branchResponse.data,
                isLoading: false,
            },
                function () {
                    var data = [];
                    console.log("BUG", this.state.admins.length)
                    if (this.state.admins.length > 0) {
                        for (let i = 0; i < this.state.admins.length; i++) {
                            this.setState({
                                total: this.state.admins[0].total_page
                            })
                            // let paystackS = { total_deposits1: this.state.admins[i].TOTAL_DEPOSITS.toString() }
                         
                            // let SUREBET = { deposit_count1: this.state.admins[i].deposit_count.toString() }

                            // let SUREBET2 = { withdrawal_count1: this.state.admins[i].withdrawal_count.toString() }

                            // let SUREBET3 = { total_withdrawals1: this.state.admins[i].withdrawal_count.toString() }

                            // let SUREBET4 = { net_cash_flow1: this.state.admins[i].net_cash_flow.toString() }

                            data.push ( Object.assign(this.state.admins[i]));
                            this.setState({
                                data: data
                            })
                            console.log("bugs", i);

                        }
                    } else {

                        this.setState({
                            data: data,
                            isLoading: false,

                        })
                        console.log("bugs", data);

                    }


                }
            );
        }))

    }

    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString);
    }


    render() {
        return (
            <div>
                < >
                    <Col md={12}>
                        <h4>Daily Deposits, Withdrawals, Net Cash Flow</h4><br />

                    </Col>
                    < Col md={12} lg={12} >
                        < Card >
                            <CardBody >
                                <div className="panel-body" >
                                    {this.state.isShowError ?
                                        <div className="alert alert-success" > {this.state.statusMessage}
                                        </div> : null
                                    }
                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.total}
                                        onChange={this.tableChangeHandler} />
                                </div>
                            </CardBody>

                        </Card>
                    </Col>
                </>
            </div>

        )
    }
}
